module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/ig-circle-128.2b57f7c4718314ad.png"+" 128w",
        images: [{path: "https://static.sniffspot.com/packs/img/ig-circle-128.2b57f7c4718314ad.png",width: 128,height: 128}],
        src: "https://static.sniffspot.com/packs/img/ig-circle-128.2b57f7c4718314ad.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/ig-circle-128.2b57f7c4718314ad.png"},
        
        width: 128,
        height: 128
      }